import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

const View = () => {
  const [params] = useSearchParams();
  const idt = params.get("idt");
  const [prod, setprod] = useState({});
  const [imgs, setimg] = useState([]);
  const [cur, setcur] = useState(0)
  const [rating, setrating] = useState(0);
  const {idk} = useSelector((state)=>state)
  
  const getData = async () => {
    let resp = await fetch(`https://dummyjson.com/products/${idt}`);
    if (resp.ok) {
      let res = await resp.json();
      setimg(res.images);
      setprod(res);
      setrating(res.rating)
    }
  }

  const head = Array.from({ length: rating }, (_index) => (
    <i class="fa-solid fa-star" style={{color: "red"}}></i>
  ))

  const addcart = async() =>{
    const data = {idtk: idt, title: prod.title, thumb: prod.thumbnail, price: prod.price};
    const resp = await fetch(`https://backend-ecomweb.onrender.com/api/addcart/${idk}`,{
          method: "put",
          body: JSON.stringify(data),
          headers: {'Content-type': 'application/json'},
    })
    if(resp.ok){
      let res = await resp.json();
      if(res.statuscode==1){
        alert("success")
      }
    }
  }


  useEffect(() => {
    getData();
  }, [])
  return (
    <>
      <br /> <br />
      <div className="row">
        <div className="col-lg-6">
          <div className="container">
            <table >
              <tr>
                <td colSpan={3}>  <img src={`${imgs[cur]}`} width="300px" className="img-fluid" /> </td>
              </tr>
              <tr>
                {
                  imgs.map((data, ind) => (
                    <td onClick={() => setcur(`${ind}`)} key={ind} >
                      <img src={`${data}`} key={ind} width="150px" className="img-fluid" />
                    </td>
                  ))
                }
              </tr>
            </table>
          </div>

        </div>
        <div className="col-lg-6">
          <div className="container vardbox">
            <h1>
              {prod.title}
            </h1>

            <br />
            {head}  &nbsp; &nbsp; ${prod.price} &nbsp; &nbsp; {prod.warrantyInformation
            } 
            <br /> <br />
            <h3> Description:  </h3>
            <p> {prod.description} </p>
            
            <div className="subinfo">
              <div> <p> Brand: <h5> {prod.brand} </h5> </p> </div>
              <div> <p> Category: <h5> {prod.category} </h5> </p> </div>
              <div>
              
               </div>
            </div>
           
          <button onClick={addcart} className="btn btn-primary"> Add to cart </button> &nbsp; &nbsp;
          <button className="btn btn-danger"> Buy Now </button>
          </div>


        </div>
      </div>

    </>
  );
};

export default View;
